export const StatusCode = {
    OK: 200,
    BAD_REQUEST: 400,
    NOT_AUTHORIZED:401,
    EMAIL_NOT_AVAIABLE:402,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500
}